import { Guid } from 'guid-typescript';
import { EventType } from '../../component/status-widget/types/Event.types';
import { Status } from '../../component/status-widget/types/StatusTracker.types';

export type CalculationFailureMessage = {
	groupId: string;
	calculationId: string;
	startedBy: string;
	completedOn: string;
};

export type CalculationInitiationMessage = {
	groupId: string;
	calculationId: string;
	startedBy: string;
	startedOn: string;
};

export type CalculationSuccessMessage = CalculationFailureMessage & {
	reportLinks: string[];
};

export type ImportMessage = {
	groupId: string;
	importId: string;
	importedBy: string;
	importedOn: string;
	isTestImport: boolean;
	clientId: string;
	message: string;
	testCaseId?: Guid;
};

export type SettingsNotification = {
	groupId: string;
	type: SettingsType;
	startedBy: string;
	completedOn: string;
};

export type ClientReferenceUploadMessage = {
	groupId: string;
	fileName: string;
	uploadedBy: string;
	uploadedOn: string;
};

export type FileComparisonNotification = {
	groupId: string;
	calculationId: string;
	processingGroupFilePaths?: string;
	outputFileNames?: string;
	fileComparisonSaveStatus: FileComparisonSaveStatus;
	startedBy: string;
}

export enum IconGroup {
	Calculation,
	Import,
	ClientReference,
	ImportSuccessWithWarning,
	Settings,
	StatusWidget,
	EnormousFileUpload
}

export enum FileComparisonSaveStatus {
	NotRun = 0,
	Passed = 1,
	Failed = 2,
	FailedDueToError = 3
}

export type SignalRImportMessage = {
	importMessage: ImportMessage;
	notificationType: NotificationType;
};

export enum NotificationType {
	Group,
	User,
}
export enum SettingsType {
	Analysis = 0,
	Library = 1,
}

export type StatusWidgetMessage = {
	groupId: string;
	reviewedBy: string;
	eventType: EventType;
	status: Status;
	reviewedByEmail: string;
	assignedTo: string;
};

export type PersistentMessage = {
	id: string;
	eventType: number;
	jobId: string;
	isSuccess: boolean;
	createdOn: Date;
	createdBy: string;
	message: string;
};

export type AutoReviewSuccessMessage = {
	groupId: string;
	calculationId: string;
	startedBy: string;
	completedOn: string;
	reportLink: string
};
export type AutoReviewFailureMessage = {
	groupId: string;
	calculationId: string;
	startedBy: string;
	completedOn: string;
};

export type CalculationCancelMessage = {
	groupId: string;
	calculationId: string;
	startedBy: string;
	startedOn: string;
};

export type EnormousFileUploadMessage = {
	groupId: string;
	fileName: string;
	uploadedBy: string;
	uploadedOn: string;
};